import mixpanel from 'mixpanel-browser'

let mixpanelToken = process.env.REACT_APP_ENV === 'production'
    ? 'c1ef3276b1db4f8077bb4129f1bc0b22'
    : '9a1bf0e0cac0732e4d53ba30e6e9bb80'
mixpanel.init(mixpanelToken)
export default mixpanel
